<script lang="ts" setup>
import type { RangeCalendarGridProps } from "reka-ui";
import type { HTMLAttributes } from "vue";
import { reactiveOmit } from "@vueuse/core";
import { RangeCalendarGrid, useForwardProps } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps<
    RangeCalendarGridProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarGrid
        data-slot="range-calendar-grid"
        :class="cn('w-full border-collapse space-x-1', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </RangeCalendarGrid>
</template>
